import convertFirstLetter from '../_internal/_convertFirstLetter';

import toUpperCase from './toUpperCase';

const upperFirst = convertFirstLetter(toUpperCase);
export default upperFirst;
